import { useSelector } from "react-redux"
import { getAllUserDetails } from "../pages/UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice"
import { GLOBAL_SETTINGS_TYPE } from "../Utils/Constant/ConstantForWebsite"

const useNewNavigation = () => {
  const userData: any = useSelector(getAllUserDetails)
  const isAdmin = localStorage.getItem('isAdmin')
  const newNavigation = userData?.globalSetting?.find((item: string) => (item === GLOBAL_SETTINGS_TYPE.NEW_NAVIGATION) || (item === GLOBAL_SETTINGS_TYPE.NEW_NAVIGATION_V3))

  return {
    userData,
    isAdmin,
    newNavigation,
  }
}

export default useNewNavigation